// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-emoji-button {
  position: relative;
}
.fi-emoji-button .emoji-button {
  color: var(--fi-emoji-picker-button-color);
  height: 30px;
  width: 30px;
}
.fi-emoji-button .emoji-button .mat-icon {
  line-height: 32px;
  font-size: 24px;
}
.fi-emoji-button .emojis-container {
  position: fixed;
  z-index: 1;
}
.fi-emoji-button .emojis-container .loading-container {
  position: absolute;
  background-color: var(--fi-color-white);
  z-index: 1;
  height: calc(100% - 95px);
  width: 100%;
  bottom: 10px;
  border: 1px solid #d9d9d9;
  border-top: none;
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-emoji-button/fi-emoji-button.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,0CAAA;EACA,YAAA;EACA,WAAA;AAER;AADQ;EACI,iBAAA;EACA,eAAA;AAGZ;AAAI;EACI,eAAA;EACA,UAAA;AAER;AAAQ;EACI,kBAAA;EACA,uCAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAEZ","sourcesContent":[".fi-emoji-button {\r\n    position: relative;\r\n    .emoji-button {\r\n        color: var(--fi-emoji-picker-button-color);\r\n        height: 30px;\r\n        width: 30px;\r\n        .mat-icon {\r\n            line-height: 32px;\r\n            font-size: 24px;\r\n        }\r\n    }\r\n    .emojis-container {\r\n        position: fixed;\r\n        z-index: 1;\r\n\r\n        .loading-container {\r\n            position: absolute;\r\n            background-color: var(--fi-color-white);\r\n            z-index: 1;\r\n            height: calc(100% - 95px);\r\n            width: 100%;\r\n            bottom: 10px;\r\n            border: 1px solid #d9d9d9;\r\n            border-top: none;\r\n            border-bottom: none;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
